const createMediaQuery = (comparison = "max-width", breakpoint, styles = {}) => {
  return {
    [`@media (${comparison}: ${breakpoint}px)`]: styles
  };
};
export {
  createMediaQuery
};
//# sourceMappingURL=createMediaQuery.js.map
